import { Action, createReducer, on } from '@ngrx/store';
import { LoadStatus } from '../../load-status';
import {
    measurementToolsFailed,
    measurementToolsLoaded,
    measurementToolsLoadedFromStorage,
} from '../actions/measurement-tools.actions';
import {
    initialMeasurementToolsState,
    MeasurementToolsCollectionState,
    MeasurementToolState,
} from '../measurement-tools-collection.state';

const setToolsReducer = (
    state: Readonly<MeasurementToolsCollectionState>,
    { tools }: { tools: MeasurementToolState[] },
): Readonly<MeasurementToolsCollectionState> => ({
    ...state,
    tools,
    status: LoadStatus.Loaded,
});

const setFailedReducer = (
    state: Readonly<MeasurementToolsCollectionState>,
): Readonly<MeasurementToolsCollectionState> => ({
    ...state,
    status: LoadStatus.Error,
});

const createMeasurementToolsReducer = createReducer(
    initialMeasurementToolsState,
    on(measurementToolsLoaded, measurementToolsLoadedFromStorage, setToolsReducer),
    on(measurementToolsFailed, setFailedReducer),
);

export function measurementToolsReducer(
    state: Readonly<MeasurementToolsCollectionState> | undefined,
    action: Action,
): Readonly<MeasurementToolsCollectionState> {
    return createMeasurementToolsReducer(state, action);
}
